import React from 'react';

import { FormattedMessage } from 'react-intl';

import { messages } from '../messages';

const statusErrorCodeToMessageMap = {
  Error001: <FormattedMessage {...messages.couldNotReachService} />,
  Error002: <FormattedMessage {...messages.couldNotRegisterWithMarketplace} />,
  Error003: <FormattedMessage {...messages.couldNotRetrieveStoreInfo} />,
  Error004: <FormattedMessage {...messages.marketplaceNotSupported} />,
  Success001: <FormattedMessage {...messages.successfulRequest} />,
};

class RegistrationStatusServiceClass {
  convertRegistrationStatusToFrontendFormat(registrationStatus) {
    return {
      isRegistered: registrationStatus.isRegistered,
      errorString: registrationStatus.statusCode.startsWith('Error') && statusErrorCodeToMessageMap[registrationStatus.statusCode],
    };
  }
}

export const RegistrationStatusService = new RegistrationStatusServiceClass();
